import React, { useState } from 'react';
import { Popover } from 'antd';
import { Icon } from 'components/common';
import { useLazyGetLeadCommentsQuery } from 'features/leads/api';
import { t } from 'i18next';
import { localisedValue } from 'utils';

const LeadCommentsPopover = ({ lead }) => {
  const [getLeadComments, { data: leadDetails, isLoading, error }] = useLazyGetLeadCommentsQuery();

  const handleOpenChange = (visible) => {
    if (visible && lead?.id) {
      getLeadComments(lead.id);
    }
  };

  const popoverContent = () => {
    if (isLoading) return <div>{t("Loading")}</div>;
    if (error) return <div style={{ color: '#dc2626' }}>{t("Error")}</div>;

    return (
      <div style={{ maxWidth: '300px', padding: '8px' }}>
        <p>
          <strong>{t("Best way to contact client")}: </strong>
          {leadDetails?.inquiry?.ExternalInquiry?.ExternalInquiryStatusChangeReason?.title}
        </p>
        <p>
          <strong>{t("Additional Information")}: </strong>
          {localisedValue({
            object: leadDetails?.inquiry?.ExternalInquiry,
            key: 'statusChangeComment'
          })}
        </p>
      </div>
    );
  };

  return (
    <Popover
      content={popoverContent()}
      trigger="click"
      onOpenChange={handleOpenChange}
    >
      <Icon
        icon="BiMessageDetail"
        color="#707070"
        size="20px"
        style={{ margin: -4, padding: 3, cursor: "pointer" }}
      />
    </Popover>
  );
};

export default LeadCommentsPopover;